var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM1.75 11C1.75 5.89137 5.89137 1.75 11 1.75C16.1086 1.75 20.25 5.89137 20.25 11C20.25 16.1086 16.1086 20.25 11 20.25C5.89137 20.25 1.75 16.1086 1.75 11ZM7.59919 15.4504C7.35042 15.7816 6.88027 15.8484 6.54908 15.5997C6.21789 15.3509 6.15107 14.8808 6.39984 14.5496C7.4476 13.1546 9.1182 12.25 10.9999 12.25C12.8816 12.25 14.5522 13.1546 15.5999 14.5496C15.8487 14.8808 15.7819 15.3509 15.4507 15.5997C15.1195 15.8484 14.6493 15.7816 14.4006 15.4504C13.6239 14.4165 12.3898 13.75 10.9999 13.75C9.60992 13.75 8.37583 14.4165 7.59919 15.4504ZM9 9C9 9.55229 8.55229 10 8 10C7.44772 10 7 9.55229 7 9C7 8.44771 7.44772 8 8 8C8.55229 8 9 8.44771 9 9ZM14 10C14.5523 10 15 9.55229 15 9C15 8.44771 14.5523 8 14 8C13.4477 8 13 8.44771 13 9C13 9.55229 13.4477 10 14 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default "/Frontend/static/media/sad-face.e4b0756e6c7a4571e44386e7dfdd0457.svg";
export { ForwardRef as ReactComponent };